import { Entity } from "../base/entity";

export class DocumentContact extends Entity {
   public static readonly TABLENAME = 'document_contact';

  public static readonly DOCUMENT_ID = 'document_id';
  public static readonly FIRST_NAME = 'ime';
  public static readonly LAST_NAME = 'prezime';
  public static readonly PHONE = 'telefon';
  public static readonly EMAIL = 'email';
  public static readonly JBKJS = 'jbkjs';
  public static readonly BROJ_LK = 'broj_lk';
  public static readonly BROJ_DOZVOLE = 'broj_dozvole';

  documentId: string;
  ime: string;
  prezime: string;
  telefon: string;
  email: string;
  jbkjs: string;
  brojLk: string;
  brojDozvole: string;
}
